const DYNAMICS_LABELS: string[] = [
  'Explore',
  'Excite',
  'Examine',
  'Execute',
];

export default DYNAMICS_LABELS;
